/*
 * @Author: your name
 * @Date: 2020-03-19 09:36:58
 * @LastEditTime: 2020-04-03 10:57:15
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /fornt-work/hawk/src/router/modules/goods.js
 */
import Layout from '@/layout'

export default {
  path: '/goods',
  component: Layout,
  redirect: '/goods/list',
  name: 'goods',
  meta: {
    title: '商品管理',
    role: 1513,
    icon: 'goods'
  },
  children: [
    {
      path: 'list',
      component: () => import('@/pages/goods/list'),
      name: 'goodsList',
      meta: { title: '商品列表', role: 1514 }
    },
    {
      path: 'create/normal',
      name: 'goodsCreate',
      component: () => import('@/pages/goods/create'),
      meta: { title: '发布商品', role: 1515, type: 'NORMAL' }
    },
    {
      path: 'create/indefinite',
      name: 'goodsCreate',
      component: () => import('@/pages/goods/create'),
      meta: { title: '发布不定规格商品', role: 1611, type: 'UNCERTAIN' }
    },
    {
      path: 'update/:id',
      name: 'goodsUpdate',
      component: () => import('@/pages/goods/update'),
      hidden: true,
      meta: {
        title: '更新商品信息',
        role: 1515
      }
    },
    {
      path: 'detail/:id',
      name: 'goodsDetail',
      component: () => import('@/pages/goods/detail'),
      hidden: true,
      meta: {
        title: '商品详情',
        role: 1515
      }
    },
    {
      path: 'exportRecord',
      name: 'exportRecord',
      component: () => import('@/pages/goods/exportRecord'),
      hidden: true,
      meta: {
        title: '导入记录',
        role: 1515
      }
    },
    {
      path: 'quotation',
      name: 'quotation',
      component: () => import('@/pages/goods/quotation'),
      hidden: true,
      meta: {
        title: '我的资源单',
        role: 1515
      }
    }
  ]
}
